// extracted by mini-css-extract-plugin
module.exports = {"pales":"Pales_pales__2b4yg"};